import { render, staticRenderFns } from "./auth-box.vue?vue&type=template&id=38756d66&scoped=true"
import script from "./auth-box.vue?vue&type=script&lang=ts"
export * from "./auth-box.vue?vue&type=script&lang=ts"
import style0 from "./auth-box.vue?vue&type=style&index=0&id=38756d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38756d66",
  null
  
)

export default component.exports